export function getDayClass(day) {
    switch (day.highlight) {
        case 'start':
            return 'border-brand rounded-l-lg text-heading';
        case 'during':
            return 'bg-tertiary-medium border-transparent text-heading';
        case 'finish':
            return 'bg-brand rounded-r-lg border-transparent text-white';
        case 'startAndFinish':
            return 'bg-brand rounded-lg border-transparent text-white';
        default:
            if (day.warning)
                return 'bg-warning-soft border-transparent text-fg-warning';
            return 'border-transparent text-heading';
    }
}
